module.exports = __webpack_public_path__ + "img/rifle.47b43b6f.svg";